import { render } from "./Alert.vue?vue&type=template&id=6c617b21"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=6c617b21&lang=css"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__